import React, { useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import FailedMsg from "../../Extra/FailedMsg";
import SuccessMsg from "../../Extra/SuccessMsg";
import { MdAddCard } from "react-icons/md";

const AddNewType = ({ setAddNewType, rawMData, setDataUpdated }) => {
  //   console.log(rawMData);
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [show, setShow] = useState(false);
  const [result, setResult] = useState(false);
  const [departments, setDepartments] = useState(rawMData);
  const [selectedDept, setSelectedDept] = useState("");
  const [newDept, setNewDept] = useState("");

  const [selectedType, setSelectedType] = useState("");
  const [newType, setNewType] = useState("");

  const [selectedAsset, setSelectedAsset] = useState("");
  const [newAsset, setNewAsset] = useState("");

  const [selectedAssetDescription, setSelectedAssetDescription] = useState("");
  const [assetDesc, setAssetDesc] = useState("");
  const [readyTime, setReadyTime] = useState("");
  const [workDone, setWorkDone] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Use new if provided, otherwise use existing
    const dept = newDept || selectedDept;
    const type = newType || selectedType;
    const asset = newAsset || selectedAsset;

    if (!dept || !type || !asset || !assetDesc) {
      alert("Please fill all fields!");
      return;
    }

    // Prevent duplicates
    const deptExists = departments.find((d) => d.DEPARTMENT === dept);
    if (newDept && deptExists) {
      alert("Department already exists!");
      return;
    }

    // Build new entry
    const newEntry = {
      ASSET_DISCRIPTION: assetDesc,
      AssetReadyTime: Number(readyTime),
      Work_Done_Per_Hour: Number(workDone),
    };

    // 🔹 Send to backend
    try {
      const response = await fetch(
        `${urlBlockPrefix}insertm_block_machine_type`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify([
            { DEPARTMENT: dept, TYPE: type, ASSET: asset, ...newEntry },
          ]),
        }
      );
      const res = await response.json();
      setResult(res);
      setShow(true);
      setDataUpdated("updated");
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
    } catch (error) {
      setShow(true);
      console.error("Error submitting data:", error);
    }
  };

  // Get types from selected dept
  const currentTypes =
    departments.find((d) => d.DEPARTMENT === selectedDept)?.children || [];

  // Get assets from selected type
  const currentAssets =
    currentTypes.find((t) => t.TYPE === selectedType)?.children || [];
  // Get assets description   from selected type
  const currentAssetsDescription =
    currentAssets.find((t) => t.ASSET === selectedAsset)?.data || [];
  useEffect(() => {
    if (newDept) {
      setSelectedDept("");
    }
    if (newType) {
      setSelectedType("");
    }
    if (newAsset) {
      setSelectedAsset("");
    }
  }, [newDept, newType, newAsset]);
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      style={{
        position: "fixed", // fixed position ensures full screen coverage
        top: 0,
        left: 0,
        width: "100vw", // full viewport width
        height: "100vh", // full viewport height
        zIndex: 1050, // ensure it's on top
        background: "rgba(152, 152, 152, 0.44)",
        // cursor: "-moz-grab",
      }}
      onClick={() => {
        setAddNewType((prev) => {
          setAddNewType(!prev);
        });
      }}
    >
      <div
        className=" m-0 p-0 position-relative"
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        <div
          className="position-absolute top-0 start-100 translate-middle "
          onClick={() => {
            setAddNewType((prev) => {
              setAddNewType(!prev);
            });
          }}
        >
          <div
            className="papaDivNM d-flex aline-items-center"
            style={{
              height: "20px ",
              width: "20px",
              borderRadius: "100%",
              background: "white",
            }}
          >
            <IoMdCloseCircle
              style={{
                fontSize: "20px",
                color: "red",
                cursor: "pointer",
              }}
            />
          </div>
        </div>
        <div>
          <div className="papaDiv">
            <div className="">
              <h5 className="bg-dark text-white p-1">
                <MdAddCard /> Add New Machine
              </h5>
              <form className="p-4 border rounded space-y-4">
                {/* Department */}
                <div>
                  <label>
                    Department:<b style={{ color: "red" }}>*</b>{" "}
                  </label>
                  <div className="d-flex">
                    <select
                      className="form-select "
                      disabled={newDept != ""}
                      value={selectedDept}
                      onChange={(e) => setSelectedDept(e.target.value)}
                    >
                      <option value="">-- Select Department --</option>
                      {departments.map((d) => (
                        <option key={d.DEPARTMENT} value={d.DEPARTMENT}>
                          {d.DEPARTMENT.replace(/_/g, " ")}
                        </option>
                      ))}
                    </select>

                    <input
                      className="form-control"
                      type="text"
                      placeholder="Or add new Department"
                      value={newDept}
                      onChange={(e) => setNewDept(e.target.value)}
                    />
                  </div>
                  {newDept &&
                  departments.some(
                    (d) =>
                      d.DEPARTMENT.replace(/_/g, " ").toLowerCase() ===
                      newDept.toLowerCase()
                  ) ? (
                    <b style={{ color: "red" }}>Department already exists!</b>
                  ) : (
                    <div> </div>
                  )}
                  <br />
                  {/* Type */}
                  {selectedDept || newDept ? (
                    <div>
                      <label>
                        Type:<b style={{ color: "red" }}>*</b>
                      </label>
                      <div className="d-flex">
                        <select
                          className="form-select"
                          disabled={newType != ""}
                          value={selectedType}
                          onChange={(e) => setSelectedType(e.target.value)}
                        >
                          <option value="">-- Select Type --</option>
                          {currentTypes.map((t) => (
                            <option key={t.TYPE} value={t.TYPE}>
                              {t.TYPE}
                            </option>
                          ))}
                        </select>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Or add new Type"
                          value={newType}
                          onChange={(e) => setNewType(e.target.value)}
                        />
                      </div>{" "}
                    </div>
                  ) : null}

                  {newType &&
                  currentTypes.some(
                    (d) =>
                      d.TYPE.replace(/_/g, " ").toLowerCase() ===
                      newType.toLowerCase()
                  ) ? (
                    <b style={{ color: "red" }}>Type already exists!</b>
                  ) : (
                    <div>
                      {/* Asset */}
                      {(selectedType || newType) &&
                      (selectedDept || newDept) ? (
                        <div>
                          <label>
                            Asset:<b style={{ color: "red" }}>*</b>
                          </label>
                          <div className="d-flex">
                            <select
                              disabled={newAsset != ""}
                              className="form-select"
                              value={selectedAsset}
                              onChange={(e) => setSelectedAsset(e.target.value)}
                            >
                              <option value="">-- Select Asset --</option>
                              {currentAssets.map((a) => (
                                <option key={a.ASSET} value={a.ASSET}>
                                  {a.ASSET}
                                </option>
                              ))}
                            </select>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Or add new Asset"
                              value={newAsset}
                              onChange={(e) => setNewAsset(e.target.value)}
                            />
                          </div>
                        </div>
                      ) : null}
                      {newAsset &&
                      currentAssets.some(
                        (d) =>
                          d.ASSET.replace(/_/g, " ").toLowerCase() ===
                          newAsset.toLowerCase()
                      ) ? (
                        <b style={{ color: "red" }}>Asset already exists!</b>
                      ) : (
                        <div>
                          {/* Final Asset Data */}
                          {selectedAsset || newAsset ? (
                            <div>
                              <div className="d-flex">
                                {currentAssetsDescription.length > 0 && (
                                  <div>
                                    Existing Asset Description
                                    <select className="form-select">
                                      <option>
                                        Existing Asset Description
                                      </option>
                                      {currentAssetsDescription.map((a) => (
                                        <option key={a.ASSET_DISCRIPTION}>
                                          {a.ASSET_DISCRIPTION}
                                        </option>
                                      ))}
                                    </select>
                                  </div>
                                )}
                                <div>
                                  machine name<b style={{ color: "red" }}>*</b>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Asset Description"
                                    value={assetDesc}
                                    onChange={(e) =>
                                      setAssetDesc(e.target.value)
                                    }
                                  />
                                </div>
                                <div>
                                  Ready Time (sec)
                                  <input
                                    className="form-control"
                                    type="number"
                                    placeholder="Ready Time (sec)"
                                    value={readyTime}
                                    onChange={(e) =>
                                      setReadyTime(e.target.value)
                                    }
                                  />
                                </div>
                                <div>
                                  Work Done Per Hour
                                  <input
                                    className="form-control"
                                    type="number"
                                    placeholder="Work Done Per Hour"
                                    value={workDone}
                                    onChange={(e) =>
                                      setWorkDone(e.target.value)
                                    }
                                  />
                                </div>
                              </div>
                              {assetDesc &&
                              currentAssetsDescription.some(
                                (d) =>
                                  d.ASSET_DISCRIPTION.toLowerCase().trim() ===
                                  assetDesc.toLowerCase().trim()
                              ) ? (
                                <b style={{ color: "red" }}>
                                  Machine already exists!
                                </b>
                              ) : (
                                <div></div>
                              )}
                            </div>
                          ) : null}
                          {newAsset &&
                          currentAssets.some(
                            (d) =>
                              d.ASSET.replace(/_/g, " ").toLowerCase() ===
                              newAsset.toLowerCase()
                          ) ? (
                            <b style={{ color: "red" }}>
                              Asset already exists!
                            </b>
                          ) : (
                            <div></div>
                          )}
                          <br />
                          <div className="row ">
                            <button
                              className="btn  btn-outline-success"
                              onClick={handleSubmit}
                            >
                              Insert
                            </button>
                          </div>
                        </div>
                      )}
                      <br />
                    </div>
                  )}
                  <br />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className="p-3">
        {result && result.status === "ok" ? (
          <SuccessMsg
            head="Success"
            message={result.message}
            show={show}
            setShow={setShow}
          />
        ) : (
          result && (
            <FailedMsg
              head="Failed"
              message={result.message || "Failed to complete the task"}
              show={show}
              setShow={setShow}
            />
          )
        )}
      </div>
    </div>
  );
};

export default AddNewType;
